import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button } from '@ipc/ipc-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { deleteEdiRfidAuditExecutionRequestActionCreator } from '../redux/actions/EdiRfidAuditExecutionDeleteActions';
import { getCheckedRows } from '../../redux/selectors/EdiRfidAuditRequestExecutionsSelectors';

class EdiRfidAuditExecutionDeleteDialog extends Component {
  constructor(props) {
    super(props);
    this.confirmDelete = this.confirmDelete.bind(this);
  }

  async confirmDelete() {
    if (this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0) {
      const executionIdsList = [];
      this.props.checkedRows.forEach((row) => executionIdsList.push(row.executionId));
      await this.props.deleteEdiRfidAuditExecutionRequestActionCreator(
        executionIdsList,
      );
      this.props.refreshExecutionList();
    }
    this.props.closeDialog();
  }

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Delete EDI-RFID Audit Execution</DialogTitle>
        <div>
          <p style={{ padding: '5px' }}>Are you sure you want to delete these execution/s?</p>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirmDelete}
            className="primary-button-false"
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    );
  }
}

EdiRfidAuditExecutionDeleteDialog.propTypes = {
  deleteEdiRfidAuditExecutionRequestActionCreator: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  checkedRows: PropTypes.arrayOf(PropTypes.object),
  refreshExecutionList: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    checkedRows: getCheckedRows(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  deleteEdiRfidAuditExecutionRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EdiRfidAuditExecutionDeleteDialog);
